export const bookingApiQueryKeys = {
  basicInfo: (orgSlug: string, tourSlug: string) =>
    ['booking', orgSlug, tourSlug, 'basicInfo'] as const,

  quote: (
    orgSlug: string,
    tourSlug: string,
    clientFormKey: string,
    promoCodes: string[],
  ) =>
    ['booking', orgSlug, tourSlug, 'quote', clientFormKey, promoCodes] as const,

  participantForm: (orgSlug: string, tourSlug: string) =>
    ['booking', orgSlug, tourSlug, 'participantForm'] as const,

  getParticipantForm: (orgSlug: string, tourSlug: string) =>
    ['booking', orgSlug, tourSlug, 'getParticipantForm'] as const,

  bookingTourOptions: (
    orgSlug: string,
    tourSlug: string,
    participantBirthday: string,
  ) =>
    [
      'booking',
      orgSlug,
      tourSlug,
      'bookingOptions',
      participantBirthday,
    ] as const,
  bookingInsurances: (orgSlug: string, tourSlug: string) =>
    ['booking', orgSlug, tourSlug, 'insurances'] as const,
  tourConsents: (orgSlug: string, tourSlug: string) =>
    ['booking', orgSlug, tourSlug, 'tourConsents'] as const,
  consentPreview: (orgSlug: string, tourSlug: string, consentId: string) =>
    ['booking', orgSlug, tourSlug, 'consentPreview', consentId] as const,
};
